import React, { useEffect } from 'react';

import Text from '~components/atoms/Text';
import ActionButton from '~components/atoms/ActionButton';
import TabPageContainer from '~components/atoms/TabPageContainer';
import TabPageHeaderWrapper from '~components/atoms/TabPageHeaderWrapper';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { ModuleEnum, PermissionsEnum } from '~utils/enums';
import { GoldSilverInventoryTabs } from '~utils/constants';

import TabSelector from '~components/atoms/TabSelector';
import InventoryListingPaginator from './InventoryListingPaginator';
import InventoryListingSearchAndFilterBar from './InventoryListingSearchAndFilterBar';
import InventoryListingTable from './InventoryListingTable';
import CreateInventoryModal from './CreateInventoryModal';
import TransferInventoryModal from './TransferInventoryModal';

import * as Styles from './_goldSilverInventory.module.scss';
import { GoldSilverInventorySelectedTab } from '~types/redux/state';

const GoldSilverInventory = () => {
    const dispatch = useAppDispatch();
    const setIsCreateInventoryModalOpen = (value: boolean) => dispatch(combinedActions.goldSetIsCreateInventoryModalOpen(value));
    const setIsTransferInventoryModalOpen = (value: boolean) => dispatch(combinedActions.goldSetIsTransferInventoryModalOpen(value));
    const setSelectedInventoryTab = (value: GoldSilverInventorySelectedTab) => {
        dispatch(combinedActions.goldSetSelectedInventoryTab(value));
        dispatch(combinedActions.goldSetInventoryListingIndex({ index: 0 }));
    };
    const isCreateInventoryModalOpen = useAppSelector((state) => state.gold.modals.isCreateInventoryModalOpen);
    const isTransferInventoryModalOpen = useAppSelector((state) => state.gold.modals.isTransferInventoryModalOpen);
    const selectedInventoryTab = useAppSelector((state) => state.gold.goldInventory.inventoryListing.selectedTab);

    const inventoryListingIndex = useAppSelector((state) => state.gold.goldInventory.inventoryListing.index);
    const viewAccessModules = useAppSelector(state => state.auth.userDetails.access)?.find(access => access.permission === PermissionsEnum.View)?.modules || [];
    const createAccessModules = useAppSelector(state => state.auth.userDetails.access)?.find(access => access.permission === PermissionsEnum.Create)?.modules || [];
    const filters = useAppSelector((state) => state.gold.goldInventory.inventoryListing.filters);

    useEffect(() => {
        dispatch(combinedActions.branchGetAllBranchesAttempt());
    }, []);

    useEffect(() => {
        dispatch(combinedActions.goldGetAllProductsAttempt());
        dispatch(combinedActions.goldGetInventoryListingAttempt());
    }, [inventoryListingIndex, selectedInventoryTab]);

    const isPaperTab =
        selectedInventoryTab === GoldSilverInventorySelectedTab.GoldIslamicPaper
        || selectedInventoryTab === GoldSilverInventorySelectedTab.GoldConventionalPaper
        || selectedInventoryTab === GoldSilverInventorySelectedTab.SilverIslamicPaper
        || selectedInventoryTab === GoldSilverInventorySelectedTab.SilverConventionalPaper;

    const renderActionButtons = () => {
        if (viewAccessModules.find(module => module === ModuleEnum.Inventory)) {
            return (
                <div className={Styles['action-container']}>
                    {
                        createAccessModules.find(module => module === ModuleEnum.Inventory)
                        &&
                        (
                            <ActionButton
                                testId='create-inventory-modal-open-button'
                                label='Create Inventory'
                                onClick={() => setIsCreateInventoryModalOpen(true)}
                            />
                        )
                    }

                    {
                        createAccessModules.find(module => module === ModuleEnum.InventoryTransfer)
                        &&
                        (
                            <ActionButton
                                testId='transfer-inventory-modal-open-button'
                                label='Transfer Inventory'
                                onClick={() => setIsTransferInventoryModalOpen(true)}
                                disabled={isPaperTab}
                                className={isPaperTab ? Styles['disabled-button'] : ''}
                            />
                        )
                    }
                </div>
            );
        }
    };
    return (
        <TabPageContainer>
            <TabPageHeaderWrapper>
                <Text
                    label='Inventory List'
                    className={Styles.title}
                    isBold
                />

                {renderActionButtons()}

            </TabPageHeaderWrapper>

            <InventoryListingSearchAndFilterBar />

            <TabSelector
                selectedTab={selectedInventoryTab}
                setSelectedTab={setSelectedInventoryTab}
                tabs={GoldSilverInventoryTabs}
            >
                <InventoryListingTable />

                <InventoryListingPaginator />
            </TabSelector>

            <CreateInventoryModal
                isOpen={isCreateInventoryModalOpen}
                onClose={() => setIsCreateInventoryModalOpen(false)}
            />

            <TransferInventoryModal
                isOpen={isTransferInventoryModalOpen}
                onClose={() => setIsTransferInventoryModalOpen(false)}
            />

        </TabPageContainer>
    );
};

export default GoldSilverInventory;
